import { NavLink, useParams, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';

import '@fortawesome/fontawesome-free/css/all.min.css';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;
let debounceTimeout: NodeJS.Timeout;

const LaunchpadDetails = () => {
  const { launchpad_slug } = useParams();
  const navigate = useNavigate();
  const [launchpadData, setLaunchpadData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentRequest = useRef(null);
  const [skeletoncard, setSkeletonCard] = useState(true);
  const fetchLaunchpadDetails = async (signal) => {
    try {
      setLoading(true);
      setError(null);
      
      const request = fetch(`${apiUrl}/get-coin-details?coin_id=${launchpad_slug}`, { signal });
      currentRequest.current = request;
      
      const response = await request;
      
      // Verify this is still the latest request
      if (currentRequest.current !== request) return;
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to fetch launchpad details');
      }
      
      if (!data || !data.id) {
        throw new Error('Launchpad data not found');
      }
      
      setLaunchpadData(data);
	  setSkeletonCard(false);
    } catch (err) {
      if (err.name !== 'AbortError') {
        setError(err.message);
        console.error('Error:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!launchpad_slug) {
      navigate('/launchpad');
      return;
    }
    
    const controller = new AbortController();
    fetchLaunchpadDetails(controller.signal);
    
    return () => {
      controller.abort();
      currentRequest.current = null;
    };
  }, [launchpad_slug, navigate]);
  
  if (error) return (
    <div className="error-container">
      <h3>Error Loading Launchpad</h3>
      <p>{error}</p>
      <button onClick={() => window.location.reload()}>Retry</button>
      <NavLink to="/launchpad">Back to Launchpads</NavLink>
    </div>
  );
  if (!launchpadData) return (
    <>
		<div className="skeleton-card">
			<div className="launchpad_mainsec">
				<div className="container">
					<div className="row">
						<div className="airdrops_mainsec">
							<div className="row">
								<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<div className="backbtn">
										<div className="skeleton skeleton-small-text"></div>
									</div>
								</div>
							</div>
							  
							<div className="row">
								<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<div className="airdrops_boxsec">
										<div className="imgbox">
											<div className="skeleton skeleton-thumbnail"></div>
										</div>
									
										<div className="contntbox">
											<div className="titlebox">
												<div className="skeleton skeleton-title"></div>
													
												<div className="status_sharebox">
													<div className="statusbox">
														<div className="skeleton skeleton-small-text"></div>
														<div className="skeleton skeleton-small-text"></div>
													</div>
												</div>
											</div>
											<div className="contntsec">
												<div className="skeleton skeleton-title"></div>
												<div className="skeleton skeleton-text"></div>
												<div className="skeleton skeleton-text"></div>
												<div className="skeleton skeleton-text"></div>
												<div className="skeleton skeleton-text"></div>
											</div>
												
											<div className="date_value_sec">
												<div className="skeleton skeleton-small-text"></div>
												<div className="skeleton skeleton-small-text"></div>
												<div className="skeleton skeleton-small-text"></div>
												<div className="skeleton skeleton-small-text"></div>
												<div className="skeleton skeleton-small-text"></div>
												<div className="skeleton skeleton-small-text"></div>
												<div className="skeleton skeleton-small-text"></div>
											</div>

											<div className="high_low_data">
												<div className="boxsec">
													<span className="title_txt"><div className="skeleton skeleton-title"></div></span>
													
													<span>
													  <div className="skeleton skeleton-title"></div>
													  <div className="skeleton skeleton-small-text"></div>
													</span>
												</div>
												
												<div className="boxsec">
													<span className="title_txt"><div className="skeleton skeleton-title"></div></span>
													
													<span>
													  <div className="skeleton skeleton-title"></div>
													  <div className="skeleton skeleton-small-text"></div>
													</span>
												</div>
											</div>
											
											<div className="btn_mainsec">
												<div className="skeleton skeleton-thumbnail"></div>
											</div>
										</div>
									</div>	
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
  	</>
  );

return (
<div className="launchpaddetails_wrapper">
	<div className="launchpad_mainsec">
		<div className="container">
		    <div className="row">
		        <div className="airdrops_mainsec">
		            <div className="row">
		                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
		                  	<div className="backbtn">
			                    <NavLink to="/launchpad">
			                      <i className="fas fa-arrow-left"></i> Back to Launchpad
			                    </NavLink>
		                  	</div>
		                </div>
		            </div>
		              
		            <div className="row">
		                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
		                  	<div className="airdrops_boxsec">
			                    <div className="imgbox">
			                      <img 
			                        alt="Launchpad" 
			                        src={launchpadData.image?.large || '/images/default-launchpad.png'} 
			                        onError={(e) => {
			                          e.target.src = '/images/default-launchpad.png';
			                        }}
			                      />
			                    </div>
		                    
			                    <div className="contntbox">
			                     	<div className="titlebox">
				                        <h3>{launchpadData.name || 'Unnamed Launchpad'}
				                        </h3>
											
										<div className="status_sharebox">
											<div className="statusbox">
												<span className="active">
													<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check-circle2 w-3 h-3 mr-1"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>
														
														{launchpadData.symbol}
												</span>
											</div>
												
											<div className="sharebox">
												<i className="fas fa-share-alt"></i>
											</div>
										</div>
									</div>
									<div className="contntsec">
										<h4>About</h4>
										<p>{launchpadData.description?.en || ''}</p>
									</div>
										
									<div className="date_value_sec">
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500">
											<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z">
											</path>
											<circle cx="7.5" cy="7.5" r=".5" fill="currentColor">
											</circle>
											</svg>
											<span> Current Price :</span>
											<span className={`updown_txt ${
					                              launchpadData?.market_data?.current_price?.usd >= 0 
					                                ? "upcoin" 
					                                : "downcoin"
					                            }`}
					                          >
					                            {launchpadData?.market_data?.current_price?.usd >= 0 ? (
					                              <i className="fas fa-caret-up"></i>
					                            ) : (
					                              <i className="fas fa-caret-down"></i>
					                            )}
					                            
					                          </span>
											<span className={`updown_txt ${launchpadData?.market_data?.current_price?.usd >= 0 ? 'upcoin' : 'downcoin'}`}>${launchpadData?.market_data?.current_price?.usd.toLocaleString()}
											</span>
										</div>

										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500">
											<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z">
											</path>
											<circle cx="7.5" cy="7.5" r=".5" fill="currentColor">
											</circle>
											</svg>
											<span> Price change % 1H :</span>
											<span className={`updown_txt ${
					                            launchpadData?.market_data?.price_change_percentage_1h_in_currency?.usd >= 0 
					                                ? "upcoin" 
					                                : "downcoin"
					                            }`}
					                         >
					                            {launchpadData?.market_data?.price_change_percentage_1h_in_currency?.usd >= 0 ? (
					                              <i className="fas fa-caret-up"></i>
					                            ) : (
					                              <i className="fas fa-caret-down"></i>
					                            )}
				                        	</span>    
				                            {launchpadData?.market_data?.price_change_percentage_1h_in_currency?.usd !== undefined && (
				                              <span className={`updown_txt ${launchpadData?.market_data?.price_change_percentage_1h_in_currency?.usd >= 0 ? 'upcoin' : 'downcoin'}`}>
				                                {Math.abs(launchpadData.market_data.price_change_percentage_1h_in_currency.usd).toFixed(2)}%
				                              </span>
				                            )}
				                          
										</div>
										
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
                          					<span>Market Cap: ${launchpadData.market_data.market_cap.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
										</div>
										
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Fully Diluted Valuation : ${launchpadData.market_data.fully_diluted_valuation.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
										</div>
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Total volume : ${launchpadData.market_data.total_volume.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
										</div>
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>Total Supply : {launchpadData.market_data.total_supply.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
										</div>
										<div className="boxsec">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-tag w-4 h-4 mr-2 text-pink-500"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>
											
											<span>
					                            Max Supply : {launchpadData?.market_data?.max_supply != null 
					                              ? launchpadData.market_data.max_supply.toLocaleString('en-US', { 
					                                  minimumFractionDigits: 2, 
					                                  maximumFractionDigits: 2 
					                                })
					                              : "NA"
					                            }
					                          </span>
										</div>
										
									</div>

									<div className="high_low_data">
										<div className="boxsec">
											<span className="title_txt">All-Time High</span>
				                            <span>
				                              <h3>
				                                {launchpadData?.market_data?.ath?.usd 
				                                  ? `${launchpadData.market_data.ath.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
				                                  : 'N/A'}
				                                {launchpadData?.market_data?.ath_change_percentage?.usd && (
				                                  <span className={launchpadData.market_data.ath_change_percentage.usd >= 0 ? "upcoin" : "downcoin"}>
				                                    {launchpadData.market_data.ath_change_percentage.usd >= 0 ? (
				                                      <i className="fas fa-caret-up"></i>
				                                    ) : (
				                                      <i className="fas fa-caret-down"></i>
				                                    )}
				                                    {Math.abs(launchpadData.market_data.ath_change_percentage.usd).toFixed(2)}%
				                                  </span>
				                                )}
				                              </h3>
				                              <p>
				                                {launchpadData?.market_data?.ath_date?.usd 
				                                  ? new Date(launchpadData.market_data.ath_date.usd).toLocaleDateString() 
				                                  : 'Date not available'}
				                              </p> 
				                            </span>
										</div>
										<div className="boxsec">
											<span className="title_txt">All-Time Low</span>
				                            <span>
				                              <h3>
				                                {launchpadData?.market_data?.atl?.usd 
				                                  ? `$${launchpadData.market_data.atl.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
				                                  : 'N/A'}
				                                {launchpadData?.market_data?.atl_change_percentage?.usd && (
				                                  <span className={launchpadData.market_data.atl_change_percentage.usd >= 0 ? "upcoin" : "downcoin"}>
				                                    {launchpadData.market_data.atl_change_percentage.usd >= 0 ? (
				                                      <i className="fas fa-caret-up"></i>
				                                    ) : (
				                                      <i className="fas fa-caret-down"></i>
				                                    )}
				                                    {Math.abs(launchpadData.market_data.atl_change_percentage.usd).toFixed(2)}%
				                                  </span>
				                                )}
				                              </h3>
				                              <p>
				                                {launchpadData?.market_data?.atl_date?.usd 
				                                  ? new Date(launchpadData.market_data.atl_date.usd).toLocaleDateString() 
				                                  : 'Date not available'}
				                              </p>
				                            </span>
										</div>
									</div>
									
									<div className="btn_mainsec">
										<a className="btn_style" href="#">Participate Now</a>
									</div>
								</div>
							</div>	
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

);
};

export default LaunchpadDetails;